<template>
  <section v-if="!experiments.disableMediaRail" id="media-rail" class="media-rail">
    <Slideshow
      v-if="headerData && items.length"
      :list="items"
      :show-indicator="false"
      @slideshow-change-click="tagPromoBanner"
      @click="popupLinkHandler"
    >
      <template #item="slotProps">
        <div class="content-wrapper grid-x align-middle align-center">
          <!-- eslint-disable vue/no-v-html -->
          <span class="content heavy-sm white-color" :data-index="slotProps.index" v-html="slotProps.data.text"></span>
          <!-- eslint-enable -->
        </div>
      </template>
    </Slideshow>
    <Skeleton v-else-if="isDesktop && !headerData" height="40px" />
  </section>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { computed, watch } from 'vue';
import Skeleton from '@nuxt-common/atomic-ui/app/components/skeleton/Skeleton';

import Slideshow from '../common/Slideshow';
import { GET_HEADER_DATA, GET_IS_DESKTOP_VIEW } from '#shared/types/getters';
import { tagPromoBanner } from '#shared/features/analytics/promoBannerTags.bcom';
import dispatchNavigationAdBannerRendered from '~/utils/dispatchNavigationAdBannerRendered';
import useExperiments from '~/composables/useExperiments';
import { usePopupLink } from '~/composables/features/usePopupLink';

const navHeader = useNavHeader();
const navViewType = useNavViewType();

const experiments = useExperiments();
const { popupLinkHandler } = usePopupLink();

const headerData = computed(() => navHeader?.[GET_HEADER_DATA]);

const items = computed(() => headerData.value?.topNavigation || []);
const isDesktop = computed(() => navViewType[GET_IS_DESKTOP_VIEW]);

watch(headerData, (value) => {
  if (value && !value.topNavigation?.length) {
    dispatchNavigationAdBannerRendered();
  }
});
</script>

<style lang="scss" scoped brand="bcom">
:deep(a) {
  color: $white;
}

:deep(.slideshow-item) {
  margin: auto 0;
}

.media-rail {
  background-color: $black;
  color: $white;
}

.content-wrapper {
  padding: 12px 86px 12px 52px;
}

.content {
  text-align: center;
}

@include breakpoint(large up) {
  .content-wrapper {
    padding: 12px;
  }
}
</style>
